if (!customElements.get('greeting-field')) {
  class GreetingField extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.checkboxes = this.querySelectorAll('[data-gift-checkbox]');
      this.fields = this.querySelector('[data-gift-fields]');
      this.propertyInputs = this.querySelectorAll('[data-gift-property]');
      this.attributeInputs = this.querySelectorAll('[data-gift-attribute]');

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.handleGiftChange.bind(this));
      });
      this.propertyInputs.forEach((input) => {
        input.addEventListener('input', this.syncAttributes.bind(this));
      });
    }

    handleGiftChange(evt) {
      const checkbox = evt.currentTarget;
      const wrapper = checkbox.closest('[data-gift-wrapper]');
      const index = wrapper.dataset.giftIndex;
      const giftIdInput = this.querySelector(`[data-gift-id][data-gift-index="${index}"]`);

      wrapper.classList.toggle('checked', checkbox.checked);
      if (giftIdInput) giftIdInput.disabled = !checkbox.checked;

      if (index === '1' && this.fields) {
        this.fields.hidden = !checkbox.checked;
        this.propertyInputs.forEach((input) => {
          input.required = checkbox.checked;
          input.disabled = !checkbox.checked;
          if (!checkbox.checked) input.value = '';
        });
        if (!checkbox.checked) this.syncAttributes();
      }

      this.dispatchEvent(new CustomEvent('greeting:change', {
        bubbles: true,
        detail: { index, selected: checkbox.checked }
      }));
    }

    syncAttributes() {
      this.attributeInputs.forEach((attributeInput) => {
        const source = Array.from(this.propertyInputs).find(
          (input) => input.dataset.giftProperty === attributeInput.dataset.giftAttribute
        );
        attributeInput.value = source ? source.value : '';
      });

      this.dispatchEvent(new CustomEvent('greeting:change', { bubbles: true }));
    }

    getSelectedItems() {
      return Array.from(this.querySelectorAll('[data-gift-id]:not([disabled])')).map((input) => {
        const item = {
          id: Number(input.value),
          quantity: 1,
          title: input.dataset.productTitle,
          variantTitle: input.dataset.variantTitle,
          price: Number(input.dataset.price)
        };

        if (input.dataset.giftIndex === '1') {
          item.properties = {};
          this.propertyInputs.forEach((propertyInput) => {
            item.properties[propertyInput.dataset.giftProperty] = propertyInput.value;
          });
        }

        return item;
      });
    }

    getAttributes() {
      const attributes = {};
      this.attributeInputs.forEach((input) => {
        if (input.value) attributes[input.dataset.giftAttribute] = input.value;
      });
      return attributes;
    }

    reportValidity() {
      return Array.from(this.propertyInputs).every((input) => input.reportValidity());
    }
  }

  customElements.define('greeting-field', GreetingField);
}
